import { createStore } from 'vuex'
import commonStore from './common/index'
import userStore from './user/index'
import redisStore from './redis/index'
import orderStore from './orders/index'
export default createStore({
  modules: {
    commonStore,
    userStore,
    redisStore,
    orderStore
  }
})
